export default angular.module('gm.wealth.common')
  .directive('gmwDigitsOnly', gmwDigitsOnly)
  .name;

function gmwDigitsOnly() {
  'ngInject';

  const directive = {
    link,
    restrict: 'A',
    require: 'ngModel',
  };
  return directive;

  function link(scope, _element, _attrs, ctrl) {
    scope.ctrl = ctrl;
    scope.model = {};

    ctrl.$parsers.push((value) => {
      const newValue = value.replace(/[^0-9]/g, '');
      ctrl.$setViewValue(newValue);
      ctrl.$render();
      return newValue;
    });
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/common/directives/digits-only/digits-only.js